/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<737478c90565b05b3f884724c0aaf814>>
 * @relayHash d2700534ff2e849c4ed110974647b6c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39f0f08d113d046973208e0f481f22328de2ea8d7584d611449439d781ab221c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type conversationModalQuery$variables = Record<PropertyKey, never>;
export type conversationModalQuery$data = {
  readonly me: {
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"ConversationInputUser" | "ConversationUser">;
    };
  };
};
export type conversationModalQuery = {
  response: conversationModalQuery$data;
  variables: conversationModalQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "conversationModalQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "AuthenticationContext",
          "kind": "LinkedField",
          "name": "me",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationUser"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ConversationInputUser"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW",
              "path": "me.user"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "me"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "conversationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "type": "AtlassianAccountUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "39f0f08d113d046973208e0f481f22328de2ea8d7584d611449439d781ab221c",
    "metadata": {},
    "name": "conversationModalQuery",
    "operationKind": "query",
    "text": null
  }
};

(node as any).hash = "7ba5375f7af864fceb00552e0c701daa";

export default node;
